import { InjectionToken } from '@angular/core';

interface Environment {
  production: boolean;
  api: {
    baseUrl: string;
    publicKey: string;
  };
  constant: {
    siteName: string;
    hospitalName: string;
    contact: {
      phone: string;
      email: string;
    };
  };
  [key: string]: any;
}

export const ENVIRONMENT = new InjectionToken<Environment>('ENVIRONMENT');
